<template>
    <b-container>
    <b-table 
         striped hover 
         :items="items" 
         :fields="fields"
         :current-page="currentPage"
         :per-page="perPage"
        
         :sort-by.sync="sortBy"
         :sort-desc.sync="sortDesc"
         :sort-direction="sortDirection"
         
        >
        <template v-slot:cell(acciones)="row">
            <b-button size="sm" class="mr-1" @click="editar(row.item, row.index, $event.target)">
                Editar
            </b-button>
            <b-button size="sm" class="mr-1" @click="cambiarContrasena(row.item, row.index, $event.target)"
                data-toggle="tooltip" data-placement="top" title="Cambia la contraseña del usuario."
            >
               Cambiar contraseña
            </b-button>
            <b-button size="sm"  @click="eliminar(row.item, row.index, $event.target)">
                Eliminar
            </b-button>
        </template>


    </b-table>
    <!-- Info modal -->
    <b-modal :id="infoModal.id"  :title="infoModal.title" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">  
            <b-form-group
                :state="infoModal.passwordState"
                label="Contraseña"
                label-for="name-input"
                invalid-feedback="La contraseña es obligatoria"
              >
                <b-form-input
                  id="name-input"
                  v-model="infoModal.password"
                  :state="infoModal.passwordState"
                  type="password"
                  required
                ></b-form-input>

              </b-form-group>
        </form>  
    </b-modal>
     <b-col cols="6">
            <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
        </b-col>
    </b-container>
</template>

<script>
 import {mapActions,mapMutations} from 'vuex'
 import userForm from '@/components/admin/userForm'
  import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    export default {
        components:{
            userForm
        },  
        mixins : [validateMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 5,
                pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                // valor de los roles
                options: [
                  {value:1, text:'Admin'},
                  {value:2, text:'Vendedor'},
                  {value:3, text:'Ingenieria'},
                  {value:4, text:'Prensa'}
                ],
                //variable del modal
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    password: '',
                    passwordState: null,
                },
                item:[],
                
            }
        },
        methods:{
            ...mapActions({
                _eliminar: 'admin/eliminar',
                _cambiacontrasena: 'admin/cambiacontrasena'   
            }),
            ...mapMutations({
                _setUser: 'admin/setUser'
            }),
            eliminar(item, index, button){
                this._eliminar(item).then(() => {
                   //  
                })
            },
            editar(item, index, button){
                this._setUser(item)
                this.$router.push('editar_usuarios')
            },
            cambiarContrasena(item, index, button){
                this.infoModal.title = `Usuario: ${item.name}`
                this.item = item
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetModal() {
               this.infoModal.password = ''    
            },
            handleOk(bvModalEvt) {

              // Prevent modal from closing
              bvModalEvt.preventDefault()
              // Trigger submit handler
              this.handleSubmit()
            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.infoModal.passwordState = valid
                return valid
            },
            handleSubmit() {
               let payload
                // si no es valido sale de la funcion
               if (!this.checkFormValidity()) {
                 return
               }
                payload =
                    {'id':  this.item.id, 
                    'password' : this.infoModal.password
                    }
                this._cambiacontrasena(payload).then(() =>{
                     this.$bvModal.hide('info-modal')
                })

               // Hide the modal manually
              /* this.$nextTick(() => {
                
               })*/
            },
        }
        
    }
</script>

<style lang="scss" scoped>

</style>